import { IAction } from './interfaces';

export const actions: IAction[] = [];
